import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import Dict from "../../../helper/dict";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";
import {AgentRequestContext} from "../../../context/agent_context";


const TABLE_HEAD = ["#", "مباشر", "وضعیت", "گرایش‌جدید", "گرایش‌فعال", "گرایش‌ردشده", "عملیات"];

export function AgentsGrid() {

  const [selectedHead, setSelectedHead] = useState("#")

  const {agentLogs, setModalOpen, setAgentId} = useContext(AgentRequestContext)

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "agent_id",
    "مباشر": "name",
    "وضعیت": "status",
    "گرایش‌جدید": "new_branches",
    "گرایش‌فعال": "accepted_branches",
    "گرایش‌ردشده": "rejected_branches",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "مباشر": true,
    "وضعیت": true,
    "گرایش‌جدید": true,
    "گرایش‌فعال": true,
    "گرایش‌ردشده": true,
    "عملیات": false,
  }
  return (
    <div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden">
      <table className="w-full table-fixed text-left">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-100">
        {agentLogs.map(
          ({agent_id, name, phone, status, new_branches, accepted_branches, rejected_branches}, index) => {
            const isLast = index === agentLogs.length - 1;
            const classes = "p-4";

            return (
              <tr key={agent_id}>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_id)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      color={Dict(`${status}_color`)}
                      size="sm"
                      value={Dict(`${status}`)}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(new_branches)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(accepted_branches)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(rejected_branches)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="بررسی مشاور">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setAgentId(agent_id);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}